
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'お問い合わせ・ご相談',
      description: 'お電話またはメールにてお気軽にご相談ください。',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: '現地調査・お見積り',
      description: '現地調査を行い、正確なお見積りを作成いたします。',
      icon: 'ri-search-line'
    },
    {
      number: '03',
      title: '測量・登記手続き',
      description: '最新機器による測量と必要な登記手続きを実施します。',
      icon: 'ri-compass-3-line'
    },
    {
      number: '04',
      title: '完了・書類お渡し',
      description: '業務完了後、必要書類をお渡しし詳しくご説明します。',
      icon: 'ri-check-double-line'
    }
  ];

  return (
    <section id="process" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            業務の流れ
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            お問い合わせから業務完了まで、分かりやすい手順で進めてまいります。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 h-full">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-2xl text-blue-600`}></i>
                </div>
                <div className="text-2xl font-bold text-blue-600 mb-3">{step.number}</div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
          </button>
        </div>
      </div>
    </section>
  );
}